import type { ActionType, Interaction, ModelConfiguration } from "@autointel/client-api";
import { DeviceType } from "@autointel/whiz-models";
import type InteractionsListener from "../../InteractionsListener";
import { parseBmwRsUrl } from "./parser";

let lastBmwUrl: string | null = null;

export function handleBmwRsUrlChange(url: string, listener: InteractionsListener): void {
    if (!url.includes("configure.bmw.rs")) {
        return;
    }

    const config = parseBmwRsUrl(url);

    if (!config) {
        lastBmwUrl = url;
        return;
    }

    const { range, modelCode, options } = config;

    let addedFeatures: string[] = [];
    let hasChanges = true;
    const isFirstVisit = lastBmwUrl === null;

    if (lastBmwUrl) {
        const previousConfig = parseBmwRsUrl(lastBmwUrl);

        if (previousConfig) {
            const rangeChanged = previousConfig.range !== range;
            const modelChanged = previousConfig.modelCode !== modelCode;
            addedFeatures = options.filter(opt => !previousConfig.options.includes(opt));

            hasChanges = rangeChanged || modelChanged || addedFeatures.length > 0;
        }
    }

    lastBmwUrl = url;

    if (!hasChanges) {
        return;
    }

    const timestamp = Date.now();

    const modelConfiguration: ModelConfiguration = {
        id: `${listener.user?.id}-${timestamp}-${modelCode}`,
        productId: modelCode,
        features: options,
        range,
    };

    let subAction: string | undefined;
    if (isFirstVisit) {
        subAction = "first option selected (configuration now saved in url)";
    } else if (addedFeatures.length > 0) {
        subAction = addedFeatures.join(',');
    }

    const interaction: Interaction = {
        itemId: `${window.location.pathname}-${timestamp}`,
        context: {
            browsingSession: {
                id: `${listener.user?.id}-${timestamp}`,
                ...((window.navigator as any).userAgentData?.mobile && {
                    deviceType: DeviceType.MOBILE,
                }),
            },
            user: {
                ...listener.user,
                id: listener.user?.id ?? "",
                userAgent: window.navigator.userAgent,
            },
            source: {
                url: window.location.href,
                name: document.title,
            },
            config: modelConfiguration,
        },
        action: "SELECT" as ActionType,
        subAction,
        timestamp,
    };

    if (!listener.app || !listener.user) {
        listener.unsentInteractions.push(interaction);
        return;
    }

    listener.app.postInteraction({
        interaction,
    });
}
